
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { HTMLDivProps } from 'src/typeDefs';

export interface RenderCounterProps extends HTMLDivProps {
    label?: string | null,
    /**
     * Force enable/disable this particular instance, regardless of the global RenderCounter.ENABLED status
     */
    enabled?: boolean,
    /**
     * How long to show the highlight after a render (in ms).
     * Defaults to `1000` ms
     */
    blinkTime?: number;
}

export class RenderCounter extends React.Component<RenderCounterProps> {
    static propTypes = {
        label: PropTypes.string,
        enabled: PropTypes.bool,
        blinkTime: PropTypes.number.isRequired,
    };

    static defaultProps = {
        label: 'render = ',
        blinkTime: 1000,
    };

    static ENABLED = false;
    static INSTANCES: RenderCounter[] = [];

    static enable() {
        if (_.get(window, 'process.env.NODE_ENV') === 'production') {
            return console.warn('Cannot enable RenderCounter in production mode');
        }

        RenderCounter.ENABLED = true;
        RenderCounter.INSTANCES.forEach(node => node.forceUpdate());
    }

    static disable() {
        RenderCounter.ENABLED = false;
        RenderCounter.INSTANCES.forEach(node => node.forceUpdate());
    }

    rootRef = React.createRef<HTMLDivElement>();
    counter = 0;
    timeout: any;

    componentDidMount() {
        RenderCounter.INSTANCES.push(this);
        this.blink();
    }

    componentWillUnmount() {
        RenderCounter.INSTANCES = RenderCounter.INSTANCES.filter(x => x !== this);
    }

    componentDidUpdate() {
        this.blink();
    }

    blink() {
        if (!this.rootRef.current) return;

        this.rootRef.current.dataset.active = '';
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
            if (!this.rootRef.current) return;
            delete this.rootRef.current.dataset.active;
        }, this.props.blinkTime);
    }

    render() {
        const { label, enabled, blinkTime, ...rest } = this.props;

        if (enabled != null) {
            if (!enabled) return null;
        } else if (!RenderCounter.ENABLED) return null;

        return (
            <Root {...rest} ref={this.rootRef}>
                {label}
                {++this.counter}
            </Root>
        );
    }
}

export default RenderCounter;


require('!style-loader/lib/addStyles.js')([[ module.id, ".flex {\n  display: flex;\n}\n.flex.flex-space-between {\n  align-items: space-between;\n}\n.center {\n  text-align: center;\n}\n.bold {\n  font-weight: bold;\n}\n.mt0 {\n  margin-top: 0rem !important;\n}\n.mb0 {\n  margin-bottom: 0rem !important;\n}\n.ml0 {\n  margin-left: 0rem !important;\n}\n.mr0 {\n  margin-right: 0rem !important;\n}\n.m0 {\n  margin: 0rem 0rem 0rem 0rem !important;\n}\n.mx0 {\n  margin-left: 0rem !important;\n  margin-right: 0rem !important;\n}\n.my0 {\n  margin-top: 0rem !important;\n  margin-bottom: 0rem !important;\n}\n.mt1 {\n  margin-top: 1rem !important;\n}\n.mb1 {\n  margin-bottom: 1rem !important;\n}\n.ml1 {\n  margin-left: 1rem !important;\n}\n.mr1 {\n  margin-right: 1rem !important;\n}\n.m1 {\n  margin: 1rem 1rem 1rem 1rem !important;\n}\n.mx1 {\n  margin-left: 1rem !important;\n  margin-right: 1rem !important;\n}\n.my1 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n.mt2 {\n  margin-top: 2rem !important;\n}\n.mb2 {\n  margin-bottom: 2rem !important;\n}\n.ml2 {\n  margin-left: 2rem !important;\n}\n.mr2 {\n  margin-right: 2rem !important;\n}\n.m2 {\n  margin: 2rem 2rem 2rem 2rem !important;\n}\n.mx2 {\n  margin-left: 2rem !important;\n  margin-right: 2rem !important;\n}\n.my2 {\n  margin-top: 2rem !important;\n  margin-bottom: 2rem !important;\n}\n.mt05 {\n  margin-top: 0.5rem !important;\n}\n.mb05 {\n  margin-bottom: 0.5rem !important;\n}\n.ml05 {\n  margin-left: 0.5rem !important;\n}\n.mr05 {\n  margin-right: 0.5rem !important;\n}\n.m05 {\n  margin: 0.5rem 0.5rem 0.5rem 0.5rem !important;\n}\n.mx05 {\n  margin-left: 0.5rem !important;\n  margin-right: 0.5rem !important;\n}\n.my05 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n.mt025 {\n  margin-top: 0.25rem !important;\n}\n.mb025 {\n  margin-bottom: 0.25rem !important;\n}\n.ml025 {\n  margin-left: 0.25rem !important;\n}\n.mr025 {\n  margin-right: 0.25rem !important;\n}\n.m025 {\n  margin: 0.25rem 0.25rem 0.25rem 0.25rem !important;\n}\n.mx025 {\n  margin-left: 0.25rem !important;\n  margin-right: 0.25rem !important;\n}\n.my025 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n.pt0 {\n  padding-top: 0rem !important;\n}\n.pb0 {\n  padding-bottom: 0rem !important;\n}\n.pl0 {\n  padding-left: 0rem !important;\n}\n.pr0 {\n  padding-right: 0rem !important;\n}\n.p0 {\n  padding: 0rem 0rem 0rem 0rem !important;\n}\n.px0 {\n  padding-left: 0rem !important;\n  padding-right: 0rem !important;\n}\n.py0 {\n  padding-top: 0rem !important;\n  padding-bottom: 0rem !important;\n}\n.pt1 {\n  padding-top: 1rem !important;\n}\n.pb1 {\n  padding-bottom: 1rem !important;\n}\n.pl1 {\n  padding-left: 1rem !important;\n}\n.pr1 {\n  padding-right: 1rem !important;\n}\n.p1 {\n  padding: 1rem 1rem 1rem 1rem !important;\n}\n.px1 {\n  padding-left: 1rem !important;\n  padding-right: 1rem !important;\n}\n.py1 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n.pt2 {\n  padding-top: 2rem !important;\n}\n.pb2 {\n  padding-bottom: 2rem !important;\n}\n.pl2 {\n  padding-left: 2rem !important;\n}\n.pr2 {\n  padding-right: 2rem !important;\n}\n.p2 {\n  padding: 2rem 2rem 2rem 2rem !important;\n}\n.px2 {\n  padding-left: 2rem !important;\n  padding-right: 2rem !important;\n}\n.py2 {\n  padding-top: 2rem !important;\n  padding-bottom: 2rem !important;\n}\n.pt05 {\n  padding-top: 0.5rem !important;\n}\n.pb05 {\n  padding-bottom: 0.5rem !important;\n}\n.pl05 {\n  padding-left: 0.5rem !important;\n}\n.pr05 {\n  padding-right: 0.5rem !important;\n}\n.p05 {\n  padding: 0.5rem 0.5rem 0.5rem 0.5rem !important;\n}\n.px05 {\n  padding-left: 0.5rem !important;\n  padding-right: 0.5rem !important;\n}\n.py05 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n.pt025 {\n  padding-top: 0.25rem !important;\n}\n.pb025 {\n  padding-bottom: 0.25rem !important;\n}\n.pl025 {\n  padding-left: 0.25rem !important;\n}\n.pr025 {\n  padding-right: 0.25rem !important;\n}\n.p025 {\n  padding: 0.25rem 0.25rem 0.25rem 0.25rem !important;\n}\n.px025 {\n  padding-left: 0.25rem !important;\n  padding-right: 0.25rem !important;\n}\n.py025 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n.font-small-1 {\n  font-size: 0.857142857142857rem;\n}\n.font-large-1 {\n  font-size: 1.142857142857143rem;\n}\n.font-small-2 {\n  font-size: 0.714285714285714rem;\n}\n.font-large-2 {\n  font-size: 1.285714285714286rem;\n}\n.font-small-3 {\n  font-size: 0.571428571428571rem;\n}\n.font-large-3 {\n  font-size: 1.428571428571429rem;\n}\n.font-small-4 {\n  font-size: 0.428571428571429rem;\n}\n.font-large-4 {\n  font-size: 1.571428571428571rem;\n}\n.RenderCounter-Root--1LSeu {\n  display: inline-block;\n  border-radius: 2px;\n  border: 1px solid #999;\n  box-shadow: 0 0 0 0 transparent;\n  background: #f5f8fa;\n  color: #10161a;\n  padding: 0.125rem 0.25rem;\n  font-size: 0.75rem;\n  font-family: monospace;\n  transition: all 0.5s ease;\n  white-space: nowrap;\n}\n.RenderCounter-Root--1LSeu[data-active] {\n  box-shadow: 0 0 0 3px #ff256e;\n}\n.bp3-dark .RenderCounter-Root--1LSeu {\n  background: #394b59;\n  color: #fff;\n}\n.bp3-dark .RenderCounter-Root--1LSeu[data-active] {\n  box-shadow: 0 0 0 3px #ffb700;\n}\n", '' ]]);
const { RSL_COMPONENT } = require("!../../node_modules/@pinto/react-style-loader/react-style-loader.runtime.compiled.js");
const __Root = RSL_COMPONENT('Root', 'RenderCounterRoot', 'RenderCounter-Root--1LSeu');
 const Root = __Root

